
import { Component } from "react";
import MobileStepper from '@material-ui/core/MobileStepper';
import Button from '@mui/material/Button';
import Replay from '@material-ui/icons/Replay';
import Snackbar from '@material-ui/core/Snackbar';
import MuiAlert from "@material-ui/lab/Alert";
import Container from '@mui/material/Container';
//arrow
import  {AiOutlineArrowLeft}  from 'react-icons/ai';
//router
import {Link} from 'react-router-dom'
import CardMedia from '@mui/material/CardMedia'
import CardContent from '@mui/material/CardContent';


const Quiz_Set = [
    {
        queno:"que_1",
        que : "1) what is the carrington event?",
        options : [{que_options: "A solar storm" , selected: false},{que_options:"a music concert", selected: false},{que_options:"A Programming language", selected: false}],
        ans : "A solar storm"
    },
    {
        queno:"que_2",
        que : "2) What are the causes of this phenomenon?",
        options : [{que_options: "twitter trends" , selected: false},{que_options:"solar plasma eruptions", selected: false},{que_options:"the influence of the tides", selected: false}],
        ans : "solar plasma eruptions"
    },
    {
        queno:"que_3",
        que : "3) who is richard carrington?",
        options : [{que_options: "a singer" , selected: false},{que_options:"a youtuber", selected: false},{que_options:"a datascientist", selected: false}],
        ans : "a datascientist"
    },
    {
        queno:"que_4",
        que : "4) What is the impact of these solar storms on the planet?",
        options : [{que_options: "flooding in urban areas" , selected: false},{que_options:"your bilirubina goes up", selected: false},{que_options:"it can damage satellites, electrical transformers and radio communications.", selected: false}],
        ans : "it can damage satellites, electrical transformers and radio communications."
    },
    {
        queno:"que_5",
        que : "5) What can we do to prevent the damage caused by a solar storm?",
        options : [{que_options: "using umbrella" , selected: false},{que_options:"a relocation of data centers", selected: false},{que_options:"scream and cry", selected: false}],
        ans : "a relocation of data centers"
    }
]

class Quiz extends Component{

   constructor(props){
        super(props)
        this.state = {
            activeStep:0,
            Quiz_Set : Quiz_Set,
            booleanonsubmit : false,
            Total:0,
            open:false,
            catchmsg:"",
            errormsg:""
        }
        
   }

    handleNext=()=>{
        this.setState({activeStep:this.state.activeStep+1})
    }

    handleBack=()=>{
        this.setState({activeStep:this.state.activeStep-1})
    }

    handleClose = (event, reason) => {
        if (reason === 'clickaway') {
          return;
        }
         this.setState({open : false})
      };

    onInputChange = (e) => {

          const { Quiz_Set } = this.state;
            const nexState = Quiz_Set.map(card => {
            if (card.queno !== e.target.name) return card;
            return {
                ...card,
                options: card.options.map(opt => {
                const checked = opt.que_options === e.target.value;
                return {
                    ...opt,
                    selected: checked
                }
                })
            }
            });
            this.setState({ Quiz_Set: nexState })
    }

    onsubmit = () =>{
         //   console.log(this.state.Quiz_Set)
         let list = this.state.Quiz_Set ;
         let count = 0;
         let notattempcount = 0;
     
                list.map((item,key)=>{
                    item.options.map((anslist,key)=>{
                       //  console.log("anslist.selected===>",anslist.selected)
                       if(anslist.selected === true){
                           if(anslist.que_options === item.ans){
                           //   console.log("===>",anslist.que_options,item.ans)
                               count = count + 1;
                           }
                       }else{
                        notattempcount = notattempcount + 1
                       }
                    })
                  })
          
   
       if(notattempcount<=14 && notattempcount>36){
              this.setState({booleanonsubmit:false,Total:count})
              this.setState({catchmsg:"Please attempt all questions",errormsg:"error",open:true})
       }else{
           this.setState({booleanonsubmit:true,Total:count})
       }
    }


    Snackbarrender =() =>{
        return(
          this.state.open? <Snackbar open={this.state.open} autoHideDuration={5000}  onClose={this.handleClose} style={{marginTop:'0px',width:'100%'}}>
           <MuiAlert elevation={6} variant="filled" onClose={this.handleClose} severity={this.state.errormsg} >
             {this.state.catchmsg}
           </MuiAlert>
         </Snackbar> : null
        )
      }

render(){
return(
    <CardContent sx={{ bgcolor: '#cfe8fc', height: '100vh' }}>

    <Link to="/">
    <AiOutlineArrowLeft style={{width:"100px"}}/>
    </Link>
    { this.state.booleanonsubmit ? 
        <div className="Quiz-DisplayResult"> 
           <h2> The score is {this.state.Total} Out Of 8 </h2>
             <Button onClick={()=>{this.setState({booleanonsubmit:false,activeStep:0,Quiz_Set : Quiz_Set,Total:0})}}> <Replay/> Try again </Button> 
        </div>
     :
     <div className="Quiz_container_display"> 
          {this.state.Quiz_Set.map((item,index)=>{
             if( Math.abs(this.state.activeStep - index)<=0)
             {
                return (
                    <div>

<Container  sx={{ bgcolor: '#cfe8fc'}} maxWidth="sm" style={{ textAlign: 'center', borderRadius: '10px'}}>
                      <h1>{item.que}</h1>
                      </Container>
                            {item.options.map((ans,index_ans)=>{
                                index_ans = index_ans + 1
                                return (
                                    <div key={index_ans} style={{ textAlign: 'center'}}>
                                        <Button >
                                        {index_ans}] {ans.que_options}
                                    <input
                                       key={index_ans}
                                       type="radio"
                                       name={item.queno}
                                       value={ans.que_options}
                                       checked={!!ans.selected}
                                       onChange={this.onInputChange}
                                   />
                                   </Button>
                                    </div>
                                    )
                            })}
                     

                    </div>

                )
             }else{
                 return null
             }
              
          })}
          

       <div className="Quiz-MobileStepper">
        <MobileStepper  variant="dots" steps={this.state.Quiz_Set.length} position="static" activeStep={this.state.activeStep}
            nextButton={
                this.state.activeStep === 7 ? 
                <Button size="small" onClick={this.onsubmit}>
                 Submit
                </Button>
                :
                <Button size="small" onClick={this.handleNext} disabled={this.state.activeStep === this.state.Quiz_Set.length}>
                Next
                </Button>

            }
            backButton={
                <Button size="small" onClick={this.handleBack} disabled={this.state.activeStep === 0}>
                    Back
                </Button>
            }
        />
        </div>
     </div>
    }
     {this.Snackbarrender()}
  </CardContent>
   )
  }
}

export default Quiz;